import { gql } from '@apollo/client'

export const CHANGE_PLAN_LOCATION = gql`
  mutation ChangePlanLocation($input: PlanLocationInput) {
    changePlanLocation(input: $input) {
      plan_location_id
      place
      longitude
      latitude
    }
  }
`

export const REMOVE_PLAN_LOCATION = gql`
  mutation RemovePlanLocation($plan_location_id: Int) {
    removePlanLocation(plan_location_id: $plan_location_id) {
      plan_location_id
      place
      longitude
      latitude
    }
  }
`
export const CHANGE_LOCATION = gql`
  mutation ChangeLocation($input: LocationInput) {
    changeLocation(input: $input) {
      location_id
      location_data_id
      place
      street
      country_code
      postal
      city
    }
  }
`

export const REMOVE_LOCATION = gql`
  mutation RemoveLocation($location_id: String) {
    removeLocation(location_id: $location_id) {
      location_id
      location_data_id
      place
      street
      country_code
      postal
      city
    }
  }
`

export const ADD_ROOM_TO_PLAN_LOCATION = gql`
  mutation AddRoomToPlanLocation($plan_location_id: Int, $room_id: Int) {
    addRoomToPlanLocation(
      plan_location_id: $plan_location_id
      room_id: $room_id
    ) {
      room_id
      name
      description
      location_data_id
      room_group_id
      room_group_name
    }
  }
`

export const REMOVE_ROOM_FROM_PLAN_LOCATION = gql`
  mutation RemoveRoomFromPlanLocation($plan_location_id: Int, $room_id: Int) {
    removeRoomFromPlanLocation(
      plan_location_id: $plan_location_id
      room_id: $room_id
    ) {
      room_id
      name
      description
      location_data_id
      room_group_id
      room_group_name
    }
  }
`
